import { combineReducers } from 'redux';
import { TOGGLE_VISIBILITY, CLOSE } from '../actions/notes_control_panel';
import { switcher } from './utils';

const is_open = switcher(false, {
    [TOGGLE_VISIBILITY](state, action) {
        return !state;
    },
    [CLOSE](state, action) {
        return false;
    },
});

export default combineReducers({
    is_open,
});



// WEBPACK FOOTER //
// ./src/reducers/notes_control_panel.js